import { StyledTable, TableHeadRow, TableHeadCell } from './styled';
import { HoldingRow } from './HoldingRow';
import type { DividendHoldingItem } from '../../../types/portfolioDividend';
import { Text, Box, Grid } from '@simplywallst/ui-core';
import { HoldingTypeRow } from './HoldingTypeRow';
import { formatCurrencyToScaleTruncated } from '@/utilities/portfolio/formatValue';

interface Props {
  holdingsList: DividendHoldingItem[];
  currencyISO: string;
  isAnalysisRestricted: boolean;
}

export const DataTable = ({
  holdingsList,
  currencyISO,
  isAnalysisRestricted,
}: Props) => {
  const declaredPayment = true;
  const estimatedPayment = true;

  return (
    <>
      <Box
        position="sticky"
        zIndex="1"
        top="var(--table-header-top)"
        height="var(--table-header-height)"
        backgroundColor="noir"
        paddingTopMd="x4"
        paddingLeft="x1"
        paddingLeftMd="x2"
      >
        <Grid
          templateColumns="max-content max-content max-content"
          gap="16px"
          alignItems="center"
          height="inherit"
        >
          <Text typography="small">August 2024</Text>
          <Text typography="tiny" color="textSofter">
            0 declared
          </Text>
          <Text typography="tiny" color="textSofter">
            10 estimated
          </Text>
        </Grid>
      </Box>
      <StyledTable>
        <thead>
          <TableHeadRow>
            <TableHeadCell>Symbol</TableHeadCell>
            <TableHeadCell>Est Amount</TableHeadCell>
          </TableHeadRow>
        </thead>
        <tbody>
          {holdingsList.length === 0 ? (
            <tr>
              <td colSpan={4}>
                <Box backgroundColor="phantom" padding="x2">
                  <Text
                    typography="xSmall"
                    color="textSubtle"
                    textAlign="center"
                  >
                    You currently have no holdings that pay dividends
                  </Text>
                </Box>
              </td>
            </tr>
          ) : (
            <>
              {declaredPayment && (
                <HoldingTypeRow
                  type="declared"
                  total={formatCurrencyToScaleTruncated(1000, currencyISO)}
                />
              )}

              {holdingsList.map((holding: DividendHoldingItem) => (
                <HoldingRow
                  key={holding.tickerSymbol}
                  holding={holding}
                  currencyISO={currencyISO}
                  isAnalysisRestricted={isAnalysisRestricted}
                />
              ))}
              {estimatedPayment && (
                <HoldingTypeRow
                  type="estimated"
                  total={formatCurrencyToScaleTruncated(2000, currencyISO)}
                />
              )}
              {holdingsList.map((holding: DividendHoldingItem) => (
                <HoldingRow
                  key={holding.tickerSymbol}
                  holding={holding}
                  currencyISO={currencyISO}
                  isAnalysisRestricted={isAnalysisRestricted}
                />
              ))}
            </>
          )}
        </tbody>
      </StyledTable>
    </>
  );
};
